export const PAGE_SIZE_OPTIONS = ['5', '10', '20', '50'];
export const DEFAULT_PAGE_SIZE = 10;
export const COLUMN_EXTRA_SMALL = 120;
export const COLUMN_SMALL = 140;
export const COLUMN_PRE_MEDIUM = 160;
export const COLUMN_MEDIUM = 180;
export const COLUMN_PRE_LARGE = 200;
export const COLUMN_LARGE = 220;
export const COLUMN_EXTRA_LARGE = 280;
export const SCROLL_Y = 'calc(100vh - 21em)';
export const SCROLL_Y_WITH_SUMMARY = 'calc(100vh - 26em)';
export const LABEL_SPAN = 10;
export const CONTENT_SPAN = 10;
export const DEBOUNCE_TIME = 800;
